import { createFileRoute, redirect } from '@tanstack/react-router'
import { CaseDetails } from 'pages/cases/CaseDetails'
import { caseDetailsSearchParams } from 'routes/cases/-searchParams'

const RouteComponent = () => {
  const { siteId, caseId } = Route.useSearch()

  return <CaseDetails siteID={siteId} caseID={caseId} />
}

export const Route = createFileRoute('/cases/details')({
  component: RouteComponent,
  validateSearch: caseDetailsSearchParams,
  beforeLoad: ({ search }) => {
    if (!search.caseId) {
      throw redirect({
        to: '/cases',
        search: { siteId: search.siteId },
      })
    }
  },
  staticData: {
    title: 'Case Details',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
